
import { doorQuery, deviceListQuery, doorAdd, doorPut, doorDelete } from "@/apis/accessControl";
import { buildingAll } from '@/apis/building'
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import dialogs from '@/components/dialogs/dialogs.vue'
import paging from '@/components/paging/paging.vue'
import noData from '@/components/noData/noData.vue'
import { ElMessage } from "element-plus";
import i18n from "@/locales/index";
const _t = i18n.global.t;

export default defineComponent({
    components: {
        dialogs,
        paging,
        noData
    },
    setup() {
        const state = reactive({
            centerDialogVisible: false,
            value: '',
            total: 0,
            deleteOpen: false,
            dialogAccessControl: false,
            LadderControlData: '' as any,
            LadderControlIndex: '' as any,
            dialogTitle: _t('accessControl.accessControlAdd'),
            cascaderDisabled: false,
            flag: '', // 添加&编辑标识
            floor: '',
            form: {
                region: '',
                name: ''
            },
            rules: {
                selectRules: [{ required: true, message: 'Please select Activity zone', trigger: 'blur', }],
                name: [{ required: true, message: _t('accessControl.pleaseLabel'), trigger: 'blur', }]
            } as any,
            optionsA: [
                {
                    value: 'wanglong',
                    label: '旺龙',
                    children: [

                    ],
                },
            ],
            buildingAndFloor: [

            ] as any,
            doorList: [

            ] as any,
            options: [

            ],
            params: {
                floor_id: '',
                pageSize: 12,
                page: 1,
                limit: true
            },
            // 页码切换
            changePage(val: number) {
                state.params.page = val
                state.query()
            },
            OFF() {
                state.deleteOpen = false
            },
            ON() {
                let params = {
                    id: state.LadderControlData.id
                }

                doorDelete(params).then((res: any) => {
                    console.log('删除结果', res)
                    if (res.code == 200) {
                        state.doorList.splice(state.LadderControlIndex, 1)
                    }
                    state.deleteOpen = false
                })
            },
            // 删除
            ladderControlDelete(cardData: object, index: number) {
                state.LadderControlData = cardData
                state.LadderControlIndex = index
                state.deleteOpen = true
            },
            // 编辑
            ladderControlDeit(cardData: any, index: number) {
                console.log('cardData', cardData)   
                state.LadderControlData = cardData
                state.LadderControlIndex = index
                state.flag = 'edit'
                state.dialogAccessControl = true
                state.dialogTitle = _t('accessControl.editAccessControl')
                state.cascaderDisabled = true
                state.value = cardData.door_id
                state.form.name = cardData.nick_name // 备注名
            },
            checkChange() {
                console.log('111')
            },
            selcetChange(val: any) {
                console.log('选中的指', val)
                state.query(state.floor[1])
            },
            // dislog关闭回调
            dialogclose() {
                state.value = ''
                state.form.name = ''
                state.dialogTitle = ''
            },
            handleClose() {
                state.dialogAccessControl = false
            },
            floorChange() {
                console.log('搜索选中的值', state.floor)
                state.query(state.floor.length >= 2 ? state.floor[1] : state.floor[0])
            },
            handleChange(val: any) {
                console.log(state.value)
            },
            // 添加 || 删除
            confirm() {
                if (state.flag == 'add') {
                    let params = {
                        door_id: state.value[1],
                        nick_name: state.form.name
                    }
                    doorAdd(params).then((res: any) => {
                        console.log('添加结果', res)
                        if (res.code == '200') {
                            state.dialogAccessControl = false
                            state.query()
                        }
                        if (res.code == '60001') {
                            ElMessage.error(_t('accessControl.accessControlIdExists'))
                        }
                    })
                } else {
                    let params = {
                        door_id: state.LadderControlData.door_id,
                        nick_name: state.form.name
                    }
                    doorPut(params, state.LadderControlData.id).then((res: any) => {
                        console.log('编辑结果', res)
                        if (res.code == 200) {
                            state.dialogAccessControl = false
                            state.query()
                        }
                    })
                }

            },
            add() {
                state.flag = 'add'
                state.dialogTitle = _t('accessControl.accessControlAdd')
                state.dialogAccessControl = true
                state.cascaderDisabled = false
            },
            query(floor_id: string = '-1') {

                state.params.floor_id = floor_id
                console.log(state.params)
                doorQuery(state.params).then((res: any) => {
                    console.log('门禁查询', res)
                    state.total = res.data.total
                    state.doorList = res.data.list
                })
            },
            init() {
                state.query()
                // 门禁设备查询
                deviceListQuery({ sn: 'b0416f03d030' }).then((res: any) => {
                    console.log('设备数据', res)
                    res.data.map((item: any) => {
                        item.value = item.deviceUnique
                        item.label = item.deviceUnique
                    });
                    state.optionsA[0].children = res.data
                })
                buildingAll('').then((res: any) => {
                    console.log('全部楼宇楼层', res)
                    res.data.forEach((item: any) => {
                        item.label = item.name
                        item.value = item.ID
                        if (item.floor_list) {
                            item.floor_list.forEach((el: any) => {
                                el.label = el.name
                                el.value = el.ID
                            })
                        }
                        item.children = item.floor_list
                    });
                    state.buildingAndFloor = res.data
                    state.buildingAndFloor.unshift({ value: 0, label: _t('public.notAssociatedFloor') })
                    state.buildingAndFloor.unshift({ value: -1, label: _t('public.all') })
                    state.floor = state.buildingAndFloor[0].value // 默认选中全部
                    console.log('state.floor', state.floor)
                })
            }
        })

        onMounted(() => {
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
